import type { FC } from "react";

import StepEmpty from "@/assets/icons/step-empty";
import StepFull from "@/assets/icons/step-full";

type ProgressStepProps = {
  isFirst: boolean;
  isLast: boolean;
};

const ProgressStep: FC<ProgressStepProps> = ({ isFirst, isLast }) => {
  return (
    <div className="flex flex-col items-center gap-1 pb-1">
      {isFirst ? <div className="w-[2px] h-4 rounded-sm bg-brand-600" /> : null}
      {isLast ? (
        <>
          <StepEmpty />
          <div className="w-[2px] h-3 rounded-sm bg-gray-200" />
        </>
      ) : (
        <>
          <StepFull />
          <div className="w-[2px] h-[55px] rounded-sm bg-brand-600" />
        </>
      )}
    </div>
  );
};

export default ProgressStep;
